function getCookieValue(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(";").shift()

  return null
}

export class TrackingServiceKlaviyo {
  constructor(pipelineConfig) {
    this.defaultParameters = {
      pageCode: window.location.pathname.split(pipelineConfig.pathPrefix)[1].split("/")[0] || null,
      pipe: pipelineConfig.pathPrefix,
      claritySessionID: decodeURIComponent(getCookieValue("_clsk")).split("|")[0] || null,
      pipe_id: pipelineConfig.pipelineId,
      language: pipelineConfig.language,
      geography: pipelineConfig.geography,
      brand_code: pipelineConfig.brandCode,
      pipe_series: pipelineConfig.series,
      eventSourceSystem: "cppv3",
      eventSourcePlatform: "web",
    }
    this._isKlaviyoAvailableCached = null
  }

  isKlaviyoAvailable() {
    if (this._isKlaviyoAvailableCached !== null) {
      return this._isKlaviyoAvailableCached
    }

    const isAvailable =
      typeof window.klaviyo === "object" &&
      window.klaviyo !== null &&
      typeof window.klaviyo.track === "function" &&
      typeof window.klaviyo.identify === "function"

    this._isKlaviyoAvailableCached = isAvailable

    return isAvailable
  }

  generateUniqueId() {
    // Use crypto.randomUUID if available
    if (
      typeof window !== "undefined" &&
      window.crypto &&
      typeof window.crypto.randomUUID === "function"
    ) {
      return window.crypto.randomUUID()
    }
    // Fallback: Generate a UUID-like string using Math.random()
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0
      let v = c === "x" ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }

  mergeData(data) {
    let uniqueId
    let eventId

    // Check for crypto.randomUUID support
    if (
      typeof window !== "undefined" &&
      window.crypto &&
      typeof window.crypto.randomUUID === "function"
    ) {
      uniqueId = window.crypto.randomUUID()
      eventId = window.crypto.randomUUID()
    } else {
      uniqueId = this.generateUniqueId()
      eventId = this.generateUniqueId()
    }

    this.defaultParameters["unique_id"] = uniqueId
    this.defaultParameters["$event_id"] = eventId

    return { ...this.defaultParameters, ...data }
  }

  trackClick(customData) {
    if (!this.isKlaviyoAvailable()) return
    const data = this.mergeData(customData)

    window.klaviyo.track("click", data)
  }

  trackPageView(customData) {
    if (!this.isKlaviyoAvailable()) return
    const data = this.mergeData(customData)

    window.klaviyo.track("page viewed", data)
  }

  trackIdentify(customData, callBackFn) {
    if (!this.isKlaviyoAvailable()) return
    window.klaviyo.identify(customData, callBackFn)
  }

  trackSystemEvent(customData) {
    if (!this.isKlaviyoAvailable()) return
    const data = this.mergeData(customData)

    window.klaviyo.track("system event", data)
  }

  setEventToSessionStorage(customData) {
    const data = this.mergeData(customData)
    const sessionStorageKey = "klaviyoTrackEventsList"

    const sessionStorageValue = JSON.parse(sessionStorage.getItem(sessionStorageKey)) || []
    sessionStorageValue.push(data)
    sessionStorage.setItem(sessionStorageKey, JSON.stringify(sessionStorageValue))
  }

  trackSessionStorageClickEvent(payload) {
    if (!this.isKlaviyoAvailable()) return

    window.klaviyo.track("click", payload)
  }

  resetUserData() {
    document.cookie = "__kla_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
  }

  async isUserIdentified() {
    if (!this.isKlaviyoAvailable()) return

    return window.klaviyo.isIdentified()
  }
}
